<template>
  <div class="synthesis-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/synthesis/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>代表项目展示</span>
    </p>
    <div
      class="section-container intro-box-content"
      style="margin-bottom: 80px"
    >
      <p>琳琅满目的商品，南来北往的人流，商机在这里孕育，财富在这里汇聚。</p>
      <p>新希望商业综合体，汇聚世界机遇，掌控财富脉搏。</p>
    </div>
    <div class="section-container">
      <el-row :gutter="20">
        <el-col
          :span="12"
          v-for="(item, index) in list"
          :key="item.name + index"
          class="wow animate__slideInUp"
          data-wow-duration="500ms"
        >
          <div class="top-box">
            <img :src="item.image" alt="" />
          </div>
          <div class="bottom-box">
            <div class="bottom-left">
              <p class="name">{{ item.name }}</p>
              <p class="address">{{ item.address }}</p>
            </div>
            <div class="bottom-right">
              <p>项目概况</p>
              <div class="desc">
                <p
                  v-for="(ele, i) in item.desc || []"
                  :key="i"
                  v-html="ele"
                ></p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "SynthesisPage",
  data() {
    return {
      list: [
        {
          name: "南宁大商汇",
          desc: [
            "落成时间：项目1期2010年投入运营，2期2014年投入运营，3期2015年投入运营",
            "总建筑面积：28.6万㎡",
            "总占地面积：245亩",
            "经营业态组合：1期为国际建材城，2期为东盟红木城，3期为国际家居博览中心",
          ],
          address: "Add：南宁市西乡塘区",
          image: require("../../../assets/images/synthesis/nndsh.jpg")
        },
        {
          name: "昆明大商汇",
          desc: [
            "落成时间：2006年",
            "总建筑面积：约90.5万㎡",
            "总占地面积：约270亩",
            "经营业态组合：住宅、公寓、盒子商业、特色商业街区",
          ],
          address: "Add：昆明市西山区大商汇 广福路与希望路交叉口",
          image: require("../../../assets/images/synthesis/kmdsh.jpg")
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    })
  }
};
</script>
<style lang="scss" scoped>
.synthesis-container {
  .top-box {
    overflow: hidden;
    width: 100%;
    > img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .bottom-box {
    height: 235px;
    overflow: hidden;
    background-color: #ecedee;
    display: flex;
    .bottom-left {
      height: 100%;
      width: 45%;
      padding-top: 23px;
      padding-left: 23px;
      position: relative;
    }

    .bottom-right {
      height: 100%;
      color: #565c61;
      box-sizing: border-box;
      padding-top: 23px;
      width: 55%;
      padding-right: 23px;

      > p {
        line-height: 40px;
        font-size: 14px;
      }
    }
  }

  .name {
    text-align: justify;
    font-size: 28px;
    line-height: 40px;
    color: #008048;
  }

  .address {
    position: absolute;
    text-align: justify;
    width: 70%;
    left: 23px;
    top: 135px;
    font-size: 14px;
    line-height: 24px;
    color: #565c61;
  }

  .desc {
    > p {
      margin-bottom: 8px;
      line-height: 18px;
      font-size: 13px;
      text-align: justify;
      word-break: break-all;
    }
  }
}
</style>
